import { render, staticRenderFns } from "./StaffNotificationHistoryModal.vue?vue&type=template&id=51ea18de&scoped=true"
import script from "./StaffNotificationHistoryModal.vue?vue&type=script&lang=js"
export * from "./StaffNotificationHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./StaffNotificationHistoryModal.vue?vue&type=style&index=0&id=51ea18de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea18de",
  null
  
)

export default component.exports